import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseCloseIcon = ({ className }: IProps) => (
    <svg
        className={className}
        fill="none"
        height="22"
        stroke="black"
        viewBox="0 0 22 22"
        width="22"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M2 2L19.4357 20.2138Z" />
        <path d="M2 20.2138L19.4357 2Z" />
        <path
            d="M2 2L19.4357 20.2138M2 20.2138L19.4357 2"
            strokeLinecap="round"
            strokeWidth="3.23162"
        />
    </svg>
);

export const CloseIcon = styled(BaseCloseIcon)``;
